import React, { useEffect } from 'react';
import { Modal, Form, Input } from 'antd';
import { UserDisplay } from '../../../../pages/users/types/UserDisplay';
import './EditUserModal.css';

interface EditUserModalProps {
  isOpen: boolean;
  user: UserDisplay | null;
  isLoading?: boolean;
  onCancel: () => void;
  onSubmit: (values: EditUserFormValues) => void;
}

export interface EditUserFormValues {
  firstName: string;
  lastName: string;
}

const EditUserModal: React.FC<EditUserModalProps> = ({
  isOpen,
  user,
  isLoading = false,
  onCancel,
  onSubmit,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (isOpen && user) {
      form.setFieldsValue({
        firstName: user.firstname,
        lastName: user.lastname,
        email: user.email,
        personalPhone: user.phone?.replace(/\s/g, '') || '',
      });
    }
  }, [isOpen, user, form]);

  if (!user) return null;

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      onSubmit(values);
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Modifier l'utilisateur"
      open={isOpen}
      onCancel={handleCancel}
      onOk={handleSubmit}
      okText="Enregistrer"
      cancelText="Annuler"
      confirmLoading={isLoading}
      centered
      width={560}
      className="edit-user-modal"
      okButtonProps={{ className: 'edit-user-modal__submit-btn' }}
      cancelButtonProps={{ className: 'edit-user-modal__cancel-btn' }}
    >
      <Form
        form={form}
        layout="vertical"
        requiredMark={(label, { required }) => (
          <>
            {required && <span className="edit-user-modal__required-mark">*</span>}
            {label}
          </>
        )}
        className="edit-user-modal__form"
      >
        <div className="edit-user-modal__row">
          <Form.Item
            label="Prénom"
            name="firstName"
            rules={[{ required: true, message: 'Le prénom est requis' }]}
            className="edit-user-modal__field"
          >
            <Input placeholder="Jean" />
          </Form.Item>
          <Form.Item
            label="Nom"
            name="lastName"
            rules={[{ required: true, message: 'Le nom est requis' }]}
            className="edit-user-modal__field"
          >
            <Input placeholder="Dupont" />
          </Form.Item>
        </div>

        <div className="edit-user-modal__row">
          <Form.Item label="Email" name="email" className="edit-user-modal__field">
            <Input placeholder="exemple@example.com" disabled />
          </Form.Item>
          <Form.Item
            label="Téléphone personnel"
            name="personalPhone"
            className="edit-user-modal__field"
          >
            <Input placeholder="0764923732" disabled />
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

export default EditUserModal;
